"use client";

import { ChevronRight } from "lucide-react";

import { Collapsible, CollapsibleContent, CollapsibleTrigger } from "@/components/ui/collapsible";
import {
  SidebarGroup,
  SidebarGroupLabel,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  SidebarMenuSub,
  SidebarMenuSubButton,
  SidebarMenuSubItem,
} from "@/components/ui/sidebar";
import { Badge } from "@/components/ui/badge";
import { Link } from "react-router";
import { useAppSelector } from "@/lib/store";

export function NavMain() {
  const { menu: items, loading } = useAppSelector((state) => state.config);
  const totalUnreadCount = useAppSelector((state) => state.messages.totalUnreadCount);
  if (loading) {
    return (
      <SidebarGroup>
        <SidebarGroupLabel>Platform</SidebarGroupLabel>
        <SidebarMenu>
          <div className="px-4 py-2 text-sm text-muted-foreground">Loading menu...</div>
        </SidebarMenu>
      </SidebarGroup>
    );
  }
  return (
    <SidebarGroup>
      <SidebarGroupLabel>Platform</SidebarGroupLabel>
      <SidebarMenu>
        {items.map((item) => {
          if (item?.items && item?.items?.length > 0) {
            return (
              <Collapsible key={`${item.url} ${item.title}`} asChild defaultOpen={item.isActive} className="group/collapsible">
                <SidebarMenuItem>
                  <CollapsibleTrigger asChild>
                    <SidebarMenuButton tooltip={item.title} size="lg">
                      {item.icon && <span className="icon" dangerouslySetInnerHTML={{ __html: item.icon }} />}
                      <span>{item.title}</span>
                      <ChevronRight className="ml-auto transition-transform duration-200 group-data-[state=open]/collapsible:rotate-90" />
                    </SidebarMenuButton>
                  </CollapsibleTrigger>
                  <CollapsibleContent>
                    <SidebarMenuSub>
                      {item.items?.map((subItem) => (
                        <SidebarMenuSubItem key={subItem.title}>
                          <SidebarMenuSubButton asChild className="py-5">
                            <Link to={subItem.url}>
                              <span>{subItem.title}</span>
                            </Link>
                          </SidebarMenuSubButton>
                        </SidebarMenuSubItem>
                      ))}
                    </SidebarMenuSub>
                  </CollapsibleContent>
                </SidebarMenuItem>
              </Collapsible>
            );
          } else {
            return (
              <SidebarMenuItem key={`${item.url} ${item.title}`}>
                <Link to={item.url}>
                  <SidebarMenuButton size="lg">
                    {item.icon && <span className="icon" dangerouslySetInnerHTML={{ __html: item.icon }} />}
                    <span>{item.title}</span>
                    {item.title === "Messages" && totalUnreadCount > 0 && (
                      <Badge
                        variant="destructive"
                        className="ml-auto h-5 w-auto min-w-[20px] px-1.5 text-xs rounded-full"
                      >
                        {totalUnreadCount > 99 ? "99+" : totalUnreadCount}
                      </Badge>
                    )}
                  </SidebarMenuButton>
                </Link>
              </SidebarMenuItem>
            );
          }
        })}
      </SidebarMenu>
    </SidebarGroup>
  );
}
